import { CreateMemories } from "apiEndPoints";
import APIrequest from "services/axios";
import { logger } from "utils";

export const CreateMemoriesService = {
  MemorialService: async (bodyData, queryParams) => {
    try {
      const payload = {
        ...CreateMemories.Memorial,
        bodyData,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  GetMemorialService: async (id, queryParams, token) => {
    try {
      const payload = {
        ...CreateMemories.GetMemorial(id),
        queryParams,
        token,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  UpdateMemorialService: async (id, bodyData, queryParams) => {
    try {
      const payload = {
        ...CreateMemories.UpdateMemorial(id),
        bodyData,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  MemorialTimelineService: async (bodyData) => {
    try {
      const payload = {
        ...CreateMemories.MemorialTimeline,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  MemorialCommentService: async (bodyData) => {
    try {
      const payload = {
        ...CreateMemories.MemorialComment,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  SaveMemorialFamilyTree: async (bodyData) => {
    try {
      const payload = {
        ...CreateMemories.SaveMemorialFamilyTree,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  SaveMemorialUserPermission: async (bodyData) => {
    try {
      const payload = {
        ...CreateMemories.SaveMemorialUserPermission,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  GetMemorialUserPermission: async (permission, queryParams) => {
    try {
      const payload = {
        ...CreateMemories.GetMemorialUserPermission(permission),
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  DeleteMemorialUserPermission: async (permissionId) => {
    try {
      const payload = {
        ...CreateMemories.DeleteMemorialUserPermission(permissionId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (err) {
      logger(err);
      throw err;
    }
  },

  MemorialPermissionStatus: async (bodyData) => {
    try {
      const payload = {
        ...CreateMemories.MemorialPermissionStatus,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  MemorialAlbumService: async (bodyData) => {
    try {
      const payload = {
        ...CreateMemories.memorialAlbum,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  updateMemorialAlbumService: async (bodyData, id) => {
    try {
      const payload = {
        ...CreateMemories.updatememorialAlbum(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  deleteMemorialAlbumService: async (id) => {
    try {
      const payload = {
        ...CreateMemories.deletememorialAlbum(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  MemorialAlbumPhotoService: async (bodyData) => {
    try {
      const payload = {
        ...CreateMemories.memorialAlbumPhoto,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  updateAlbumPhoto: async (bodyData, id) => {
    try {
      const payload = {
        ...CreateMemories.putAlbumPhoto(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  deleteAlbumPhotos: async (id) => {
    try {
      const payload = {
        ...CreateMemories.deleteAlbumPhoto(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getMemorialAlbumService: async (id) => {
    try {
      const payload = {
        ...CreateMemories.getmemorialAlbum(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getMemorialAlbums: async (id, queryParams) => {
    try {
      const payload = {
        ...CreateMemories.getmemorials(id),
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getAlbumPhotoById: async (id) => {
    try {
      const payload = {
        ...CreateMemories.getAlbumPhoto(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  getMemorialTimelineService: async (memorialId, queryParams) => {
    try {
      const payload = {
        ...CreateMemories.getMemorialTimeline(memorialId),
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getTimelineById: async (timelineId) => {
    try {
      const payload = {
        ...CreateMemories.getTimeline(timelineId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  UpdateTimeline: async (timelineId, bodyData) => {
    try {
      const payload = {
        ...CreateMemories.UpdateTimeline(timelineId),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  DeleteTimeline: async (timelineId, bodyData) => {
    try {
      const payload = {
        ...CreateMemories.DeleteTimeline(timelineId),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  getCommentList: async (id, queryParams) => {
    try {
      const payload = {
        ...CreateMemories.getMemorialCommentList(id),
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getDownloadableContent: async (id, type) => {
    try {
      const payload = {
        ...CreateMemories?.getDownloadableContent(id, type),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getAllDownloadableContent: async (id) => {
    try {
      const payload = {
        ...CreateMemories?.getAllDownloadableContent(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getSingleCommentList: async (memorialId) => {
    try {
      const payload = {
        ...CreateMemories?.getSingleComment(memorialId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  updateSingleComment: async (commentId, bodyData) => {
    try {
      const payload = {
        ...CreateMemories?.editComment(commentId),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  saveFamilyTreeSpouse: async (bodyData) => {
    try {
      const payload = {
        ...CreateMemories?.saveSpouse,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getFamilyTreeById: async (familyTreeId) => {
    try {
      const payload = {
        ...CreateMemories?.getFamilyTree(familyTreeId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  updateFamilyTree: async (bodyData, familyTreeId) => {
    try {
      const payload = {
        ...CreateMemories?.updateFamilyTree(familyTreeId),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  deleteFamilyTreeById: async (memorialId) => {
    try {
      const payload = {
        ...CreateMemories?.deleteFamilyTree(memorialId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  deletePaternalTreeIndividual: async (memorialId, individualId) => {
    try {
      const payload = {
        ...CreateMemories?.deletePaternalTreeIndividual(memorialId, individualId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  deleteFamilyTreeIndividual: async (memorialId, individualId) => {
    try {
      const payload = {
        ...CreateMemories?.deleteFamilyTreeIndividual(memorialId, individualId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  deleteFamilyTreeSpouse: async (memorialId, spouseId) => {
    try {
      const payload = {
        ...CreateMemories?.deleteFamilyTreeSpouse(memorialId, spouseId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  
  getSpouseById: async (spouseId) => {
    try {
      const payload = {
        ...CreateMemories?.getSpouseById(spouseId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  updateFamilyTreeSpouse: async (bodyData, spouseId) => {
    try {
      const payload = {
        ...CreateMemories?.updateFamilyTreeSpouse(spouseId),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
